<div class="chart-container" *ngIf="!isFullscreen">
  <button
    class="fullscreen-toggle"
    (click)="toggleFullscreen()"
    *ngIf="title == PEFWeightTitle || title === PEFNormalizeTitle"
  >
    <ng-container *ngIf="!isFullscreen"><i class="fa fa-expand"></i></ng-container>
  </button>
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    *ngIf="isLoading"
    [style]="'width: 100%; height: ' + computedChartHeight + 'px; display: block;'"
  >
  </highcharts-chart>
</div>
<div class="fullscreen-chart" *ngIf="isFullscreen">
  <!-- View Mode Toggle (Chart/Table) - Updated to use icons -->
  <div class="fullscreen-layout">
    <div class="chart-area">
      <div class="table-header">
        <span style="color: rgb(51, 51, 51) !important">{{ title }}</span>
        <div class="view-mode-toggle" role="group" aria-label="View mode" *ngIf="isSuperAdmin">
          <button
            type="button"
            class="icon-toggle"
            [class.active]="viewMode === 'chart'"
            (click)="changeViewMode('chart')"
            title="Chart View"
            aria-label="Switch to chart view"
          >
            <i class="fa fa-bar-chart"></i>
          </button>
          <button
            type="button"
            class="icon-toggle"
            [class.active]="viewMode === 'table'"
            (click)="changeViewMode('table')"
            title="Table View"
            aria-label="Switch to table view"
          >
            <i class="fa fa-table"></i>
          </button>
        </div>
      </div>
      <!-- Chart View -->
      <highcharts-chart
        [Highcharts]="Highcharts"
        [options]="chartOptions"
        *ngIf="isLoading && viewMode === 'chart'"
        style="
          width: 100%;
          height: 87vh;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
      </highcharts-chart>

      <!-- Table View -->
      <div *ngIf="viewMode === 'table'">
        <piqet-common-table
          [columns]="getTableColumns()"
          [data]="getTransformedTableData()"
          [config]="getTableConfig()"
          [rowHeaderKey]="'category'"
        ></piqet-common-table>
      </div>
    </div>

    <div class="fullscreen-sidebar">
      <div class="sidebar-header">
        <h3>Chart configuration</h3>
        <div>
          <button class="fullscreen-toggle" (click)="toggleFullscreen()">
            <i class="fa fa-compress"></i>
          </button>
        </div>
      </div>

      <!-- PEF Type Toggle -->
      <div class="btn-group mr-2" role="group" aria-label="PEF type">
        <button
          type="button"
          class="btn btn-secondary"
          [ngClass]="
            selectedPEFType != WEIGHTED_TEXT ? ' modelBtn  purpleBtnHoverEffect' : 'cancelBtn'
          "
          (click)="changePEFCategories('Normalized')"
        >
          Normalized
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          [ngClass]="
            selectedPEFType == WEIGHTED_TEXT ? ' modelBtn  purpleBtnHoverEffect' : 'cancelBtn'
          "
          (click)="changePEFCategories(WEIGHTED_TEXT)"
        >
          Weighted
        </button>
      </div>

      <div class="range-selector">
        <h4>Filter by value range</h4>
        <select [value]="selectedRangeIndex" (change)="onRangeChange($event)" class="range-select">
          <option *ngFor="let range of valueRanges; let i = index" [value]="i">
            {{ range.label }}
          </option>
        </select>
      </div>

      <div class="indicator-selector">
        <h4>{{ isChartNormalized ? 'Select indicators' : 'Select scenarios' }}</h4>
        <div class="accordion">
          <div class="accordion-header" (click)="toggleAccordion()">
            <span>{{ isChartNormalized ? 'Indicators' : 'Scenarios' }}</span>
            <i
              class="fa"
              [class.fa-chevron-down]="!isAccordionOpen"
              [class.fa-chevron-up]="isAccordionOpen"
            ></i>
          </div>
          <div class="accordion-content" [class.open]="isAccordionOpen">
            <div *ngFor="let indicator of selectableIndicators" class="checkbox-item">
              <input
                type="checkbox"
                [id]="'indicator-' + indicator.index"
                [checked]="isIndicatorSelected(indicator)"
                (change)="onCheckboxChange(indicator)"
                class="chkOverview"
                style="width: 20px !important; height: 20px !important"
              />
              <label [for]="'indicator-' + indicator.index">{{ indicator.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="legend-selector">
        <h4>{{ isChartNormalized ? 'Select scenarios ' : 'Select indicators' }}</h4>
        <div class="accordion">
          <div class="accordion-header" (click)="toggleLegendAccordion()">
            <span>{{ isChartNormalized ? ' Scenarios' : 'Indicators' }}</span>
            <i
              class="fa"
              [class.fa-chevron-down]="!isLegendAccordionOpen"
              [class.fa-chevron-up]="isLegendAccordionOpen"
            ></i>
          </div>
          <div class="accordion-content" [class.open]="isLegendAccordionOpen">
            <div *ngFor="let legendItem of selectableLegendItems" class="checkbox-item">
              <input
                type="checkbox"
                [id]="'legend-' + legendItem.index"
                [checked]="isLegendItemSelected(legendItem)"
                (change)="onLegendCheckboxChange(legendItem)"
                class="chkOverview"
                style="width: 20px !important; height: 20px !important"
              />
              <label [for]="'legend-' + legendItem.index">{{ legendItem.name }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
